export var dunsRequestType = {
  FREE: 'free',
  EXPRESS: 'express'
};
export var wizardFormSections = {
  COMPANY: 'company',
  OPERATIONS: 'operations'
};
export var shareholderTypes = {
  INDIVIDUAL: 'Shareholder (Legal Individual)',
  COMPANY: 'Shareholder (Company)'
};